import { render, staticRenderFns } from "./escanear_respuestas.vue?vue&type=template&id=8a6b790e&scoped=true"
import script from "./escanear_respuestas.vue?vue&type=script&lang=js"
export * from "./escanear_respuestas.vue?vue&type=script&lang=js"
import style0 from "./escanear_respuestas.vue?vue&type=style&index=0&id=8a6b790e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6b790e",
  null
  
)

export default component.exports